import React from 'react';
import { Button, Icon, Modal, Message, Menu } from 'semantic-ui-react';
const fileDownload = require('js-file-download');

class DownloadJSONButton extends React.Component {
  state = {open : false};
  downloadJSON = this.downloadJSON.bind(this);
  checkJSON = this.checkJSON.bind(this);
  close = () => this.setState({ open: false });

  downloadJSON() {
    const {primary} = this.props;
    const data = JSON.stringify(primary, null, 2);
    fileDownload(data, 'mp3du.json');
  }

  checkJSON(e,d) {
    if (d.errors.length > 0) {
      this.setState({open : true});
    } else {
      this.downloadJSON();
    }
  }

  render() {
    const errors = evalPrime(this.props.primary);
    const {open} = this.state;

    // CSS Fix
    const inlineStyle = {
      modal : {
        position: 'fixed',
        top: '25%',
        left: '20%'
      }
    };
    return(
      <div>
      <Menu.Item onClick={this.checkJSON} errors={errors}>
        <Icon name="save" /> Download JSON File
      </Menu.Item>

      <Modal dimmer='inverted' open={open} onClose={this.close} style={inlineStyle.modal}>
        <Modal.Header><Icon name="warning circle" />Incomplete Primary File</Modal.Header>
        <Modal.Content>
          <Message negative>
            <Message.Header>Your mod-PATH3DU Primary File is missing required elements</Message.Header>
            You can still download the file, but the following missing items will need be added before
            mod-PATH3DU will be able to run it:
            <ul>
              {errors.map((error, key) => (<li key={key}>{error}</li>))}
            </ul>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button color='black' onClick={this.close} icon labelPosition="right">
            <Icon name="reply" />Return
          </Button>
          <Button color='red' onClick={this.downloadJSON} icon labelPosition="right">
            <Icon name="save" />Download Anyway
            </Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }
}

// Function to evalute if Primary File is complete
function evalPrime(primary) {
  // Assume innocence
  let errors = [];
  // Model Settings
  if (Object.keys(primary["FLOW_MODEL_TYPE"])[0]==="MODFLOW") {
    let target = primary["FLOW_MODEL_TYPE"]["MODFLOW"];
    if (target["NAME_FILE"] === undefined) { errors.push("MODFLOW Name File")   };
    if (target["GSF_FILE"] === undefined ) { errors.push("Model GSF File")      };
    if (target["IFACE"] === undefined    ) { errors.push("MODFLOW IFACE Values")};
  } else if (Object.keys(primary["FLOW_MODEL_TYPE"])[0]==="MEUK") {
      // MEUK
  } else {
    // ELSE???
    errors.push("Valid Model Type");
  }
  
  // Simulation Settings
  let target = primary["SIMULATIONS"];
  if (target.length > 0) {
    // Has sims
    for (let i=1; i < target.length; i++) {
      let thisSim = target[i][Object.keys(target[i])[0]];
      if (thisSim["NAME"] === undefined) { errors.push(`Simulation ${i} Name`)};
      // Particle Start Locations
      if (thisSim["PARTICLE_START_LOCATIONS"] !== undefined) {
        if (thisSim["PARTICLE_START_LOCATIONS"]["SHAPEFILE"] !== undefined) {
          // Shapefile Settings
          let shpfile = thisSim["PARTICLE_START_LOCATIONS"]["SHAPEFILE"];
          if (shpfile["FILE_NAME"] === undefined) { errors.push(`Simulation ${i} Particle Shapefile File Name`) };
          if (shpfile["CELLID_ATTR"] === undefined) { errors.push(`Simulation ${i} Particle Shapefile Cell ID Field`) };
          if (shpfile["TIME_ATTR"] === undefined) { errors.push(`Simulation ${i} Particle Shapefile Time Field`) };
          if (shpfile["ZLOC_ATTR"] === undefined) { errors.push(`Simulation ${i} Particle Shapefile Z-location Field`) };
        } else {errors.push(`Simulation ${i} Particle Start Location Shapefile`)};
      } else {errors.push(`Simulation ${i} Particle Start Locations`)};
    }
  } else {
    // No sims
    errors.push("One or more Simulations");
  }
  return errors;
}

export default DownloadJSONButton;